import BatchUpdateDrawer from "./BatchUpdateDrawer"

export default BatchUpdateDrawer
